export default {
  getters: {
    getById: state => id => {
      return state.data[id] ? state.data[id] : null;
    },
    getByMandateId: state => mandateId => {
      return Object.values(state.data).find(item => {
        return item.mandate_id == mandateId;
      });
    },
  },
};
